import React from 'react';
import { object } from 'prop-types';
import { StyleSheet, View } from 'react-native-web';
import InfoSwiper from '../../../../ui/InfoSwiper';
import HeaderText from '../../../../ui/HeaderText';
import { Button } from '../../../../ui';
import Image from '../../../../shared/Image';
import Separator from '../../../../ui/Separator';
import analytics from '../../../../../modules/analytics';
import clock from '../../../../../../images/icons/icon-clock.svg';
import video from '../../../../../../images/icons/icon-video-black.svg';
import chat from '../../../../../../images/icons/icon-chat.svg';
import list from '../../../../../../images/icons/icon-list.svg';
import starburst from '../../../../../../images/icons/icon-starburst.svg';
import payment from '../../../../../../images/icons/icon-payment.svg';
import calendar from '../../../../../../images/icons/icon-calendar-solid.svg';
import './VirtualAppointmentEducationSwiper.scss';

const styles = StyleSheet.create({
  icon: {
    width: 55,
    height: 55,
  },
  iconContainer: {
    width: 55,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const HeaderImage = ({ source }) => (
  <View style={styles.iconContainer}>
    <Image
      source={source}
      style={styles.icon}
      resizeMode="contain"
    />
  </View>
);

HeaderImage.propTypes = {
  source: object.isRequired,
};

const VirtualAppointmentEducationSwiper = ({ renderContainer }) => (
  <InfoSwiper
    renderContainer={renderContainer}
    className="payments-education-swiper"
    onSlideViewed={pageNo => analytics.track('pro_virtual_appointments_swiper_viewed', { page_number: pageNo + 1 })}
    onDismissed={pageNo => analytics.track('pro_virtual_appointments_swiper_dismissed', { page_number: pageNo + 1 })}
  >
    <section className="slide-1 slide-content with-background">
      <HeaderImage source={video} />
      <HeaderText>How to create virtual appointments</HeaderText>
      <Separator />
      <HeaderText level="3">
        Help clients look their best at home by offering a 1:1 video appointment.
      </HeaderText>
    </section>
    <section className="with-background slide-content">
      <HeaderImage source={list} />
      <HeaderText>STEP 1: Add a new service to your menu</HeaderText>
      <Separator />
      <HeaderText level="3">
        Set-up a new category for “Virtual Services” and create a new service
      </HeaderText>
    </section>
    <section className="with-background slide-content">
      <HeaderImage source={clock} />
      <HeaderText>
        STEP 2: Set your times and prices
      </HeaderText>
      <Separator />
      <HeaderText level="3">
        Consultations? Paid tutorials? It&apos;s up to you!
      </HeaderText>
    </section>
    <section className="with-background slide-content">
      <HeaderImage source={chat} />
      <HeaderText>
        STEP 3: Pick your virtual meeting tool
      </HeaderText>
      <Separator />
      <HeaderText level="3">
        Decide which platform you want to use.
        Facetime, Google Hangouts, and Zoom are all great options!
      </HeaderText>
    </section>
    <section className="with-background slide-content">
      <HeaderImage source={starburst} />
      <HeaderText>
        STEP 4: Email your clients
      </HeaderText>
      <Separator />
      <HeaderText level="3">
        Use our new “Virtual Appointments” email marketing
        template to let clients know what kind of virtual services you offer.
      </HeaderText>
    </section>
    <section className="with-background slide-content">
      <HeaderImage source={calendar} />
      <HeaderText>
        STEP 5: Setting up your appointment
      </HeaderText>
      <Separator />
      <HeaderText level="3">
        Once you get a booking, reach out to the client on how you will meet with them.
      </HeaderText>
      <HeaderText level="3">
        Make sure they know if they will be expecting a Facetime call or send them a
        link to a virtual meeting you have set up.
      </HeaderText>
    </section>
    <section className="with-background slide-content">
      <HeaderImage source={payment} />
      <HeaderText>
        STEP 6: Get Paid!
      </HeaderText>
      <Separator />
      <HeaderText level="3">
        Collect payment through StyleSeat via Auto Checkout or using the Request Payment feature
        so clients can easily enter their credit card details and pay you right away.
      </HeaderText>
      <HeaderText level="3">
        Once they&apos;ve paid, you can withdraw funds immediately using our Instant Deposit feature.
      </HeaderText>
      <Button
        appearance="link"
        onClick={() => window.open('https://www.styleseat.com/blog/offer-virtual-services-for-your-clients/', '_system')}
      >
        Learn More
      </Button>
    </section>
  </InfoSwiper>
);

VirtualAppointmentEducationSwiper.propTypes = {
  renderContainer: object,
};
VirtualAppointmentEducationSwiper.defaultProps = {
  renderContainer: undefined,
};

export default VirtualAppointmentEducationSwiper;
